import { render, staticRenderFns } from "./ObjectList.vue?vue&type=template&id=55ea8960&scoped=true"
import script from "./ObjectList.vue?vue&type=script&lang=js"
export * from "./ObjectList.vue?vue&type=script&lang=js"
import style0 from "./ObjectList.vue?vue&type=style&index=0&id=55ea8960&prod&lang=scss"
import style1 from "./ObjectList.vue?vue&type=style&index=1&id=55ea8960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ea8960",
  null
  
)

export default component.exports